export default __webpack_public_path__ + "static/media/circles-no-4.3dee84da.ogg";